<div class="container">
	<h3>User Access Log for {{asset.asset_name}}</h3>
	<table class="table-user-access">
		<thead>
			<tr>
				<th>Access Time</th>
				<th>User</th>
			</tr>
		</thead>
		<tbody *ngFor="let log of pageLogs">
			<tr>
				<td>{{log.ts | datetime : "offset" : asset.time_offset_hours}}</td>
				<td>{{log.email}}</td>
			</tr>
		</tbody>
	</table>
	<ngb-pagination [collectionSize]="totalLogs" [pageSize]="itemsPerPage" [(page)]="currentPage"
		(pageChange)="updatePage()" [maxSize]="10" [directionLinks]="true" [rotate]="true"></ngb-pagination>
</div>
